import { Link } from 'react-router-dom';

const premiumFeatures = [
  { icon: 'ri-user-heart-line', label: 'Cinsiyet Filtresi' },
  { icon: 'ri-map-pin-line', label: 'Ülke Filtresi' },
  { icon: 'ri-advertisement-line', label: 'Reklamsız Deneyim' },
  { icon: 'ri-vip-crown-line', label: 'Öncelikli Eşleşme' },
  { icon: 'ri-repeat-line', label: 'Yeniden Bağlan' },
  { icon: 'ri-hd-line', label: 'HD Video Kalitesi' },
];

const PremiumSection = () => {
  return (
    <section className="py-24 md:py-32 bg-[#05070d] relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute inset-0 bg-gradient-to-br from-violet-900/20 via-transparent to-cyan-900/10" />
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-violet-500/30 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-cyan-500/20 to-transparent" />
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="relative rounded-3xl overflow-hidden">
          {/* Background image */}
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=abstract%20dark%20neon%20light%20trails%2C%20electric%20blue%20and%20violet%20energy%20streams%2C%20space%20background%20with%20particles%2C%20deep%20dark%20cosmos%20atmosphere%2C%20premium%20technology%20aesthetic%2C%20cinematic%20wide%20angle&width=1400&height=600&seq=premiumbg&orientation=landscape"
              alt=""
              className="w-full h-full object-cover object-center opacity-30"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#08060f]/95 via-[#08060f]/80 to-[#08060f]/90" />
          </div>

          <div className="relative p-10 md:p-16 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left - Text */}
            <div>
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-gradient-to-r from-yellow-500/20 to-orange-500/20 border border-yellow-500/30 text-yellow-400 text-xs font-bold mb-8">
                <i className="ri-vip-crown-line" />
                ChatNow Premium
              </div>
              <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4 leading-tight">
                Sınırsız Deneyim,
                <span className="block text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-400">
                  Premium Ayrıcalık
                </span>
              </h2>
              <p className="text-white/50 text-base leading-relaxed mb-8">
                Ücretsiz kullanıcıların göremediği özelliklere erişin. Daha hızlı eşleş, daha fazla kontrole sahip ol.
              </p>

              <div className="grid grid-cols-2 gap-3 mb-10">
                {premiumFeatures.map((f) => (
                  <div key={f.label} className="flex items-center gap-3">
                    <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-yellow-500/15 text-yellow-400">
                      <i className={`${f.icon} text-sm`} />
                    </div>
                    <span className="text-white/70 text-sm">{f.label}</span>
                  </div>
                ))}
              </div>

              <Link
                to="/premium"
                className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-gradient-to-r from-yellow-500 to-orange-500 text-black font-extrabold text-base whitespace-nowrap cursor-pointer hover:from-yellow-400 hover:to-orange-400 transition-all duration-300 shadow-lg shadow-yellow-500/25 hover:scale-105"
              >
                <i className="ri-vip-crown-line" />
                Premium'u Keşfet
              </Link>
            </div>

            {/* Right - Pricing teaser */}
            <div className="flex flex-col gap-4">
              {/* Free plan */}
              <div className="p-6 rounded-2xl bg-white/4 border border-white/10 backdrop-blur-sm">
                <div className="flex items-center justify-between mb-4">
                  <span className="text-white font-bold">Ücretsiz</span>
                  <span className="text-2xl font-extrabold text-white">₺0<span className="text-white/40 text-sm font-normal">/ay</span></span>
                </div>
                <ul className="flex flex-col gap-2">
                  {['Rastgele video sohbet', 'Metin sohbeti', 'Temel bağlantı', 'Reklam destekli'].map((f) => (
                    <li key={f} className="flex items-center gap-2 text-white/50 text-sm">
                      <i className="ri-check-line text-white/30 text-sm" />
                      {f}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Premium plan */}
              <div className="relative p-6 rounded-2xl bg-gradient-to-br from-yellow-500/10 to-orange-500/10 border border-yellow-500/30 backdrop-blur-sm">
                <div className="absolute -top-3 right-6 px-3 py-1 rounded-full bg-gradient-to-r from-yellow-500 to-orange-500 text-black text-xs font-extrabold">
                  EN POPÜLER
                </div>
                <div className="flex items-center justify-between mb-4">
                  <span className="text-yellow-400 font-bold flex items-center gap-2">
                    <i className="ri-vip-crown-line" />
                    Premium
                  </span>
                  <div className="text-right">
                    <span className="text-2xl font-extrabold text-white">₺99<span className="text-white/40 text-sm font-normal">/ay</span></span>
                  </div>
                </div>
                <ul className="flex flex-col gap-2">
                  {['Ücretsiz tüm özellikler', 'Cinsiyet filtresi', 'Ülke seçimi', 'Öncelikli eşleşme', 'Reklamsız', 'Yeniden bağlan'].map((f) => (
                    <li key={f} className="flex items-center gap-2 text-white/70 text-sm">
                      <i className="ri-check-line text-yellow-400 text-sm" />
                      {f}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PremiumSection;
